import { termsSections } from "@/content/trust";
import { site } from "@/content/site";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

export default function TermsPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Terms of Service"
        description="These terms describe the service principles for Agentic Plus. If a signed commercial agreement applies, that agreement governs the customer relationship."
      />

      <Section title="Service terms" tone="surface">
        <div className="max-w-4xl space-y-8">
          {termsSections.map((section) => (
            <article key={section.title}>
              <h2 className="text-2xl font-bold">{section.title}</h2>
              <p className="mt-3 leading-relaxed text-ink-soft">{section.description}</p>
            </article>
          ))}
        </div>
      </Section>

      <Section title="Questions about these terms" tone="paper">
        <div className="surface-card max-w-3xl p-7">
          <p className="text-ink-soft">
            Contact{" "}
            <a className="font-bold underline" href={`mailto:${site.email}`}>
              {site.email}
            </a>{" "}
            if you need the governing terms for an existing account or a procurement review.
          </p>
        </div>
      </Section>
    </>
  );
}
